import React, { useEffect, useState } from 'react';
import {
  fromRole,
  getProfileHeightString,
  getProfileWeightString,
  isUndefinedNullEmpty,
  SbCurrentUser,
} from '../submission_boards/component/SbModel';
import { Menu } from '@headlessui/react';
import MenuItemCustom from '../submission_boards/component/MenuItemCustom';
import {
  ArrowDownToLineIcon,
  BriefcaseBusinessIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  EllipsisVerticalIcon,
  Globe2Icon,
  HeartIcon,
  LayoutGridIcon,
  LocateIcon,
  LocationEditIcon,
  MailIcon,
  MapPinIcon,
  MarsIcon,
  Maximize2Icon,
  Minimize2Icon,
  MoveVerticalIcon,
  PhoneIcon,
  PlusIcon,
  RulerIcon,
  SquareUserIcon,
  TextIcon,
  WeightIcon,
  WholeWordIcon,
} from 'lucide-react';
import { useIsMobile } from '../submission_boards/component/useIsMobile';
import FilePreviewer from '../submission_kits/components/FilePreviewer';
import SbProfileDetail from '../submission_boards/recipient/SbProfileDetail';

interface SubmissionKitPageProps {
  currentUser: SbCurrentUser;
  user: any;
  projects: any;
  project: any;
  project_user: any;
  project_folder_user: any;
  show_add_sb_button: any;
  from: any;
  showProfileHeader: (show: boolean) => void;
}
// component to show profile photo/age/weight/height
// used by SbDetails and SbDetailsRecipient
export const SubmissionKitPage: React.FC<SubmissionKitPageProps> = ({
  currentUser,
  user,
  projects,
  project,
  project_user,
  project_folder_user,
  show_add_sb_button,
  from,
  showProfileHeader,
}) => {
  const isMobile = useIsMobile();
  const [gridLayout, setgridLayout] = useState(false);
  const [hmuKitDocuments, sethmuKitDocuments] = useState([]);
  const [showTopProfileHeader, setShowTopProfileHeader] = useState(true);
  useEffect(() => {
    showProfileHeader(showTopProfileHeader);
  }, [showTopProfileHeader]);
  const renderImage = (index: number, no_of_items: number) => {
    const mainKitDoc = hmuKitDocuments[index];
    const isEmpty = !mainKitDoc;

    return (
      <div className="flex flex-col gap-5 rounded-lg">
        {isEmpty ? (
          <></>
        ) : (
          <div
            className={
              'relative flex rounded-xl overflow-hidden' + (no_of_items == 1 ? ' flex-1 ' : ' ')
            }
            style={{
              width: no_of_items == 2 ? '9.8125rem' : '20rem',
              height: no_of_items == 2 ? '9.8125rem' : '20rem',
            }}
          >
            <FilePreviewer
              dynamicHeight={false}
              object_fit={"object-cover"}
              file_url={
                mainKitDoc.kit_document.cropped_file_url || mainKitDoc.kit_document.file_url
              }
              file_name={mainKitDoc.kit_document.file_name}
              file_content_type={mainKitDoc.kit_document.file_content_type}
            />
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <div
        className="flex flex-col bg-white rounded-2xl border border-blue-502 "
         style={{
          paddingTop: isMobile?'2.5rem':'2.5rem', // 40px 60px
          paddingBottom: isMobile?'2.5rem':'2.5rem', // 60px
          paddingLeft: isMobile?'1.25rem':'3.75rem', // 20px 60px
          paddingRight: isMobile?'1.25rem':'3.75rem', // 60px
          gap: isMobile?'1rem':'3.75rem', // 60px
        }}
      >
        <div className="flex flex-col sm:flex-row flex-1 justify-between items-center gap-4 border-b border-blue-502 pb-2">
          <div className="flex flex-row flex-1 items-center">
            <div className={`w-full flex-1 m-0 ${isMobile ? 'h-auto text-3xl leading-9' : 'h-12 text-3xl leading-12'} font-medium tracking-tight`} style={{ color: '#576C89' }}>
            Submission Kit
            </div>
          </div>
            {showTopProfileHeader? <div
            className="w-7 h-7 cursor-pointer  hidden sm:flex items-center justify-center overflow-hidden"
            style={{
              color: '#576C89',
            }}
            onClick={() => {
              setShowTopProfileHeader(false);
            }}
          >
            <Maximize2Icon className="w-7 h-7" />
          </div>:<div
            className="w-7 h-7 cursor-pointer  hidden sm:flex items-center justify-center overflow-hidden"
            style={{
              color: '#576C89',
            }}
            onClick={() => {
              setShowTopProfileHeader(true);
            }}
          >
            <Minimize2Icon className="w-7 h-7" />
          </div>}
        </div>

        <div className="flex flex-row gap-10">
          <div className="container mx-auto flex w-full flex-col items-end">
            <div className={(isMobile ? 'px-0' : 'p-0') + ' w-full flex justify-center'}>
              {user.submission_kit_profile && (
                <SbProfileDetail
                  currentUser={currentUser}
                  project={project}
                  submissionBoardModel={null}
                  profileUser={user.submission_kit_profile}
                  fromScreen={fromRole.PROFILE_VIEWER}
                  dialogCloseHandler={() => {
                    // setShowProfileDetails(null);
                  }}
                  refreshSubmissionBoard={() => {
                    // if (refreshSubmissionBoard) {
                    //   refreshSubmissionBoard();
                    // }
                  }}
                  prevNextProfile={async (value: number) => {
                    return false;
                  }}
                ></SbProfileDetail>
              )}
            </div>
          </div>
        </div>
      </div>{' '}
    </>
  );
};
